import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LanguageService } from '@trading-fe/services';

const SUPPORTED_LANGS = ['en', 'hy', 'ru'];

/**
 * Validates the :lang route param and syncs it with LanguageService.
 * If the lang is not supported, redirects to the saved/default language.
 */
export const langGuard: CanActivateFn = (route, state) => {
  const lang = route.paramMap.get('lang');
  const languageService = inject(LanguageService);
  const router = inject(Router);

  console.log('[langGuard]', { lang, url: state.url });

  if (!lang || !SUPPORTED_LANGS.includes(lang)) {
    const fallback = languageService.currentLang || 'en';
    const segments = state.url.split('/').filter(Boolean);
    if (segments.length > 0) {
      segments[0] = fallback;
    } else {
      segments.push(fallback);
    }
    const redirect = '/' + segments.join('/');
    console.log('[langGuard] → redirect to', redirect);
    return router.parseUrl(redirect);
  }

  languageService.setLang(lang);
  console.log('[langGuard] → pass');
  return true;
};

/**
 * Redirects any unmatched URL to the saved/default language prefix.
 * Used for the wildcard route.
 */
export const langRedirectGuard: CanActivateFn = (_route, state) => {
  const languageService = inject(LanguageService);
  const router = inject(Router);
  const fallback = languageService.currentLang || 'en';

  const path = state.url === '/' ? '' : state.url;
  return router.parseUrl(`/${fallback}${path}`);
};
